import React, { useMemo, useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import useLang from "hooks/useLang";
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2'

const Contact = () => {
  const { lang } = useLang();
  const schema = useMemo(
    () =>
      Joi.object({
        name: Joi.string().min(3).required(),
        email: Joi.string()
          .email({ tlds: { allow: false } })
          .required(),
        subject: Joi.string()
          .valid(...lang.home.hero_body_list)
          .required(),
        message: Joi.string().min(5).max(500).required(),
      }),
    [lang]
  );

  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitSuccessful, errors },
  } = useForm({
    resolver: joiResolver(schema, { allowUnknown: true, abortEarly: false }),
  });
  const form = useRef();

  useEffect(() => {
    if (!isSubmitSuccessful) { return }
  
    reset({
      email: "",
      name: "",
      // subject: "",
      message: ""
    })
  }, [isSubmitSuccessful])

  const onSubmit = async (d) => {
    const service_id = 'service_lxmsljc';
    const template_id = 'template_q7051kj';
    const user_id = 'OesZXuZaCvq_eIIBF';
    emailjs
    .sendForm(service_id, template_id, form.current, {
      publicKey: user_id,
      blockHeadless: true,
      blockList: {
        // The variable contains the email address
        watchVariable: 'userEmail',
      },
      limitRate: {
        // Set the limit rate for the application
        id: 'app',
        // Allow 1 request per 10s
        throttle: 60000,
      },
    })
    .then(
      async () => {
        await Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Email sent thank you for your inquiry.",
          showConfirmButton: false,
          timer: 1500
        });
        reset({})
      },
      (error) => {
        console.log('FAILED...', error?.text ?? error);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Email failed to be sent, please try again in 1 minute.",
          showConfirmButton: false,
          timer: 1500
        });
      },
    );
  };

  return (
    <React.Fragment>
      <section className="contact overflow-hidden" id="contact-adinata">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="sec-hd-custom">
                <h1 className="sec-title">{lang.contact_us.section_title}</h1>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col lg={8}>
              <div className="contact-box">
                <div className="custom-form mt-4">
                  <form
                    ref={form}
                    method="post"
                    name="myForm"
                    onSubmit={(e) => {
                      console.log("OnSubmit");
                      handleSubmit(onSubmit)(e);
                    }}
                  >
                    <Row>
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <input type="text" className="form-control contact-form" placeholder={lang.contact_us.placeholder_1} {...register("name")} />
                          {errors.name?.message && <p className="error-msg mt-1">{errors.name?.message}</p>}
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <input type="email" className="form-control contact-form" placeholder={lang.contact_us.placeholder_2} {...register("email")} />
                          {errors.email?.message && <p className="error-msg mt-1">{errors.email?.message}</p>}
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <select className="form-select form-control contact-form" placeholder={lang.contact_us.placeholder_3} {...register("subject")}>
                            {lang.home.hero_body_list.map((val, i) => (
                              <option key={i}>{val}</option>
                            ))}
                          </select>
                          {errors.subject?.message && <p className="error-msg mt-1">{errors.subject?.message}</p>}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <textarea rows="6" className="form-control contact-form h-auto" placeholder={lang.contact_us.placeholder_4} {...register("message")} />
                          {errors.message?.message && <p className="error-msg mt-1">{errors.message?.message}</p>}
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      <div className="col-lg-6">
                        <div className="text-center">
                          <input type="submit" id="submit" name="send" className="submitBnt btn btn-rounded bg-gradiant" value={lang.contact_us.send_button} />
                        </div>
                      </div>
                    </Row>
                  </form>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="my-5 py-4 justify-content-center text-center">
            <Col md={4}>
              <div>
                <i className="mdi mdi-google-maps f-50 icon-adinata"></i>
                <h5 className="mb-1">{lang.contact_us.location}</h5>
                <p className="f-14 mb-0 text-muted">Jalan Sentosa Raya No. 59, Sukmajaya, Depok Tengah II, Depok, Jawa Barat, 16411</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="mt-4 mt-lg-0">
                <i className="mdi mdi-email f-50 icon-adinata"></i>
                <h5 className="mb-1">{lang.contact_us.email}</h5>
                <p className="f-14 mb-0 text-muted">Email: solutions@iconictax.id</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="mt-4 mt-lg-0">
                <i className="mdi mdi-phone f-50 icon-adinata"></i>
                <h5 className="mb-1">{lang.contact_us.phone}</h5>
                <p className="f-14 mb-0 text-muted">+62 811 88 03 02 03</p>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="position-relative">
          <div className="contact-map">
            <iframe
              className="map"
              title="myFrame"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.0535509083375!2d106.83696840710898!3d-6.387091079617002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69ebf30aa90001%3A0x8ec75a9e92e9f49b!2sJl.%20Sentosa%20Raya%20No.59%2C%20Mekar%20Jaya%2C%20Kec.%20Sukmajaya%2C%20Kota%20Depok%2C%20Jawa%20Barat%2016417!5e0!3m2!1sen!2sid!4v1739711352193!5m2!1sen!2sid"
              width="100%"
              height="450"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Contact;
